// Core
import { useMemo, useState } from 'react';
import { Box, Text, Flex, Image, useColorModeValue } from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

// Components
import Card from 'components/Card/Card';

export default function Success (props) {
  const bgColor = useColorModeValue('rgba(255, 247, 217, 0.50)', 'rgba(24, 23, 16, 0.50)');

  return (
    <>
    	<Card 
          bg={bgColor}
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          mt={props.mt ?? 'unset'}
          variant="ghost" 
          padding='16px'
          backdropFilter="blur(15px)" 
          border="1px solid #57D175"
          mb={{ sm: '8px' }}>
          <Flex alignItems="center" gap="10px" pl="2px">
            <FaCheckCircle fontSize="21px" color="#57D175"/>
            <Text maxW={{sm: '100%', md: '70%'}} variant="text-sm">
			  {typeof props.success === 'string' ? `${props.success}` : 'Success'}
            </Text>
          </Flex>
        </Card>
    </>
  );
}